import { Injectable } from '@angular/core';

import { Route } from '@bca-shared/models/_enums';
import { RouterService } from '@bca-core/services/router.service';
import { IRootState } from '@bca-store/store.reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { selectTotalProductCount } from '@bca-store/store.selectors';
import { CanActivate } from '@angular/router';

@Injectable()
export class UserDataGuard implements CanActivate {
  constructor(
    private _store$: Store<IRootState>,
    private _routerService: RouterService
  ) {}

  canActivate(): Observable<boolean> {
    return this._store$.pipe(
      select(selectTotalProductCount),
      take(1),
      map(count => count > 0),
      tap((hasMinimumProductAmount: boolean) => {
        if (!hasMinimumProductAmount) {
          this._routerService.navigateTo(Route.COMPOSE);
        }
      })
    );
  }
}
